module.exports = __webpack_public_path__ + "img/yahoo.15ef01f2.svg";